export const shouldDropdownBeCleaned = ({ isError, disabled, value }) =>
  isError || disabled || !value
